<template>
  <v-container class="card-div">
    <router-link :to="Projlink">
      <div class="card-image" :style="{ backgroundImage: 'url('+ image +')'}"></div>
    </router-link>
    <div class="card-text-div d-flex justify-space-between align-center px-5">
      <router-link v-if="inApp" :to="link" tag="div" 
        class="card-heading cab d-flex justify-center align-center fw7 ceTxt">
        {{title}}
      </router-link>
      <a v-if="!inApp" :href="link" tag="div" 
        class="card-heading cab d-flex justify-center align-center fw7 leTxt">
        {{title}}
      </a>
      <div class="link-div d-flex flex-column justify-center align-end">
        <router-link v-if="inApp" :to="link" tag="div" 
          class="exploreLink mont fw7 d-flex justify-end align-center pb-1 riTxt">
          Explore
        </router-link>
        <a v-if="!inApp" :href="link" tag="div" 
          class="exploreLink mont fw7 d-flex justify-end align-center pb-1 riTxt">
          Explore
        </a>
        <router-link :to="Projlink" tag="div" 
          class="exploreLink mont fw7 d-flex justify-end align-center riTxt">
          More Info
        </router-link>
      </div>
      <div class="noise noiseProj"></div>
    </div>
    
  </v-container>
</template>
<!--=============================================================================-->
<!--=================================================================SCRIPTS=====-->
<!--=============================================================================-->
<script>
export default {
  name: "project-card",
  props: ['url', 'title', 'text', "link", "Projlink", 'inApp'],
  data() { return{ image: ""}
  },
  methods: {
    path(url) { return require('../../images/backgrounds/' + url);}
  }, 
  mounted() { this.image = this.path(this.url);}
}
</script>
<!--===============================================================================-->
<!--===================================================================STYLING=====-->
<!--===============================================================================-->
<style scoped>
.card-div{
  position: relative;
  margin: 0;
  height: 100%;
  padding: 0;
  width: 100%;
  background:white;
  border-radius: 5px !important;
  border: 1px solid #00000055;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden !important;}
.card-div:hover{ box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.8);}
.card-image{
  background: no-repeat center top;
  background-size: cover;
  position: relative;
  width: 100%;
  height: calc(100% - calc(30px + 5vw));}
.card-text-div{
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: calc(30px + 5vw);
  bottom: 0px;
  border-top: 2px solid #4EA792;
  left: 0;
  overflow: hidden !important;
  background: #323232;
  text-align: center;}
.card-heading{
  color: #4EA792 !important;
  width: 60%;
  height: 100%;
  z-index: 10;
  cursor: pointer;
  font-size: calc(16px + 0.8vw);
  line-height: calc(16px + 0.8vw);}
.card-heading:hover{color: #8961A0 !important;}
.link-div{
  position: relative;
  bottom: 0px;
  z-index: 10;
  left: 0px;
  height: 100%;
  width: 40%;}
.exploreLink{
  z-index: 10;
  padding-right: 10%;
  font-size: calc(10px + 0.5vw);
  color: white !important;
  cursor: pointer;}
.exploreLink:hover{
  color: #4EA792 !important;}
.noiseProj{ z-index: 0;opacity: 0.11;}
</style>
